import { Container, Row, Col } from "react-bootstrap";
import CartHeader from "./CartHeader";
import TyreBody from "./TyreBody";
import QuotationForm from "./QuotationForm";
import Scrollbars from "react-custom-scrollbars";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import Link from "next/link";
import { connect } from "react-redux";
import { fetchBatterySelectionItems, setLayer } from "../../../redux/actions/globalAction";
import { setCartBatteryParameter, setCartJourney, setShowMobileIstand } from "../../../redux/actions/cartAction";
import { isMobile } from "react-device-detect";
import { workshopPurchase } from "lib/config";

const Battery = ({
  apiData,
  getModel,
  globalData,
  getCarBrandModal,
  cart,
  fetchBatterySelectionItems,
  setCartBatteryParameter,
  setShowMobileIstand,
  setCartJourney,
  setLayer
}) => {
  const [filter, setFilter] = useState(0);
  const [type, setType] = useState(0);

  useEffect(() => {
    // setType(typeTwo)
    fetchBatterySelectionItems();
    return () => {
      if (localStorage.getItem("isCartBack")) {
        setCartBatteryParameter({
          type: null,
          isProceed: false,
          data: null
        })
      }
    }
  }, []);

  const setWidth = (data) => {
    let item = cart.batteryQuotation;
    item.type = data;
    setCartBatteryParameter(item);
  };

  const handleOBSelect = () => {
    setWidth(0);
    proceed();
  };

  const proceed = () => {
    localStorage.removeItem("isCartBack");
    let item = cart.batteryQuotation;
    item.isProceed = true;
    setCartBatteryParameter(item);
  };

  return (
    <div className="sr-service-dv1" style={{ paddingTop: "19px", overflow: "hidden" }}>
      <Scrollbars
        //   className="px-4 quotation"
        style={{ height: isMobile ? "calc(100vh - 144px)" : "calc(100vh - 144px)" }}
      >
        <Container fluid>
          <Row>
            <Col className="tyre mt-0">
              <div className="d-flex  justify-content-between align-items-center">
                <h4>
                  Service Selected:{" "}
                  <span className="text-custom-blue">New Battery</span>
                </h4>
                {isMobile ? (
                  <img onClick={() => {
                    //setShowQuoteSelect(false)
                    setShowMobileIstand(false)
                    setLayer(false)
                    localStorage.removeItem(
                      "isQuoterequest"
                    );
                    setCartJourney(workshopPurchase)

                  }} src="/assets/BACK.png" width="25px" height={25}></img>) : null}
              </div>
              <p className="text-black description">
                Please share any details or requirements that can help us to
                look out for the best Battery Quotes for your car.
              </p>
              <div className="position-relative mb-3 mt-4">
                <h4 className="mb-2">Select Size and Details</h4>
              </div>
              <div className="text-center"></div>

              <Container className="text-center">
                <Row>
                  <Col sm={6}>
                    <img src="/assets/repair/battery.svg" alt="battery" width="201" />
                  </Col>
                  <Col sm={6}>
                    <Container fluid>
                      <Row>
                        {globalData.batteryItems.map((e, index) => (
                          <Col xs={4} className="mt-2">
                            <a
                              style={{
                                padding: "5px 10px",
                                background:
                                  cart.batteryQuotation.type == e.AmpHrs
                                    ? "#0451be"
                                    : "#F3F3F3",
                                color:
                                  cart.batteryQuotation.type == e.AmpHrs
                                    ? "#fff"
                                    : "#000",
                              }}
                              onClick={() => setWidth(e.AmpHrs)}
                            >
                              {e.AmpHrs}
                            </a>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: isMobile ? "center" : "space-between",
                  paddingBottom: "20px",
                  // paddingRight: "30px",
                  marginTop: 20,
                }}
              >
                <button
                  className="open-bonnet-btn hide-in-mobile"
                  onClick={handleOBSelect}
                >
                  Let <span className="font-weight-bold">OPEN BONNET</span>{" "}
                  Decide the Size
                </button>
                {cart.batteryQuotation.type !== null && (
                  <button
                    className="otp-button"
                    style={{ background: "linear-gradient(0deg, rgba(247,146,34,1) 0%, rgba(255,50,1,1) 100%)" }}
                    onClick={proceed}
                  >
                    Proceed
                  </button>
                )}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <button
              className="open-bonnet-btn for-mobile"
              onClick={handleOBSelect}
            >
              Let <span className="font-weight-bold">OPEN BONNET</span> Decide
              the Size
            </button>
          </Row>
          {/* <div className='workshop-bottom-button' onClick={()=>{console.log(globalData)}}>
        <div className='workshop-select'>{"LET "}</div>
        <div className='workshop-select-ob'>{" OPEN BONNET "}</div>
        <div className='workshop-select'>{" SELECT MY GARAGE"}</div>
      </div> */}
        </Container>
      </Scrollbars>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchBatterySelectionItems: () => {
      dispatch(fetchBatterySelectionItems());
    },
    setCartBatteryParameter: (data) => {
      dispatch(setCartBatteryParameter(data));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Battery);

// fetchBatterySelectionItems
// export default ;
